module.exports = "/assets/site/images/icon-password.png?ec2e4ed904e87ba6114a221bd336836b";